import React, { PropsWithChildren } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { Divider } from '@vk-hr-tek/ui/Divider';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Tooltip } from '@vk-hr-tek/ui/Tooltip';

import { ProcessedSurveyPassingItem } from '../../../mappers';

interface ContentSurveysItemContainerProps {
  survey: ProcessedSurveyPassingItem;
}

export const ContentSurveysItemContainer = ({
  children,
  survey,
}: PropsWithChildren<ContentSurveysItemContainerProps>) => {
  return (
    <Box
      border={1}
      borderColor="stroke.primary"
      radius="l"
      bgcolor="bg.greyscale.primary"
      minWidth={0}
    >
      <Box display="flex" flexDirection="column" gap="12" px="24" py="16">
        <Tooltip placement="top" title={survey.title}>
          <Box width="fit-content">
            <Typography variant="h6" maxLinesCount={2}>
              {survey.title}
            </Typography>
          </Box>
        </Tooltip>

        <Box display="flex" gap="16">
          <Box display="flex" gap="4">
            <Icon name="calendar_outline" size="16" color="stroke.secondary" />
            <Typography variant="caption" noWrap>
              {survey.completedLabel}
            </Typography>
          </Box>

          <Box display="flex" gap="4">
            <Icon
              name={
                survey.anonymous
                  ? 'incognito_outline'
                  : 'user_circle_alt_outline'
              }
              size="16"
              color="stroke.secondary"
            />
            <Typography variant="caption" noWrap>
              {survey.anonymous ? 'Анонимный' : 'Неанонимный'}
            </Typography>
          </Box>

          <Box display="flex" gap="4">
            <Icon name="users_2_outline" size="16" color="stroke.secondary" />
            <Typography variant="caption" noWrap>
              Участников: {survey.passesNum || 0}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider />

      {children}
    </Box>
  );
};
